import { addDatapointConfig } from 'owa-analytics-actions';
import { toggleSplitMode } from 'owa-calendar-surface';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action, orchestrator } from 'satcheljs';
import { updateUserConfigurationAndService } from 'owa-session-store';

export const processSplitViewModeToggle = action(
    'processSplitViewModeToggle',
    (store: CalendarSurfaceStore) =>
        addDatapointConfig(
            {
                name: 'ToggleSplitMode',
                customData: {
                    CurrentDateRangeType: store.dateRangeType,
                    SplitMode: !store.isInSplitView, // log the intended state after toggle
                },
            },
            { store }
        )
);

orchestrator(processSplitViewModeToggle, actionMessage => {
    const store = actionMessage.store;
    toggleSplitMode(store);

    updateUserConfigurationAndService(
        config => {
            config.ViewStateConfiguration.CalendarViewInSplitMode = store.isInSplitView;
        },
        [
            {
                key: 'CalendarViewInSplitMode',
                valuetype: 'Boolean',
                value: [`${store.isInSplitView}`],
            },
        ],
        'OWA.ViewStateConfiguration'
    );
});
